import { render, staticRenderFns } from "./FormModals.vue?vue&type=template&id=3f2f6534&"
import script from "./FormModals.vue?vue&type=script&lang=ts&"
export * from "./FormModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2f6534')) {
      api.createRecord('3f2f6534', component.options)
    } else {
      api.reload('3f2f6534', component.options)
    }
    module.hot.accept("./FormModals.vue?vue&type=template&id=3f2f6534&", function () {
      api.rerender('3f2f6534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Warehouse/FormModals.vue"
export default component.exports